import { RestAPI } from "../API/RestAPI";
import { TireRackProductI } from "../store/useStoreSystem";
import axios from "axios";

interface BaseResponse {
    status: 'ok' | 'fail'
}
export type PartialStoreState = DeepPartial<Record<keyof any, any>> //TODO с разобраться что тут происходит
interface LoadProjectResponse extends BaseResponse {
    project?: PartialStoreState
}
interface SaveProjectResponse extends BaseResponse {
    hash: string
}

interface BitrixErrorMessage {
    ERROR: string
    MESSAGE: string
}

interface AuthByLoginResponse {
    auth: boolean
    error: string
    userId: number
}

export const Bitrix = {
    async getUserId(): Promise<number> {
        try {
            const {data} = await RestAPI.post("", {
                method: "getUserId",
            });
            return data
        } catch (e) {
            console.error(e)
            return 0
        }

    },
    async getPasswordHash(password: string) {
        return await RestAPI.post("", {
            method: "getPasswordHash",
            password
        });
    },
    async authorizationByLogin(login: string, password: string): Promise<AuthByLoginResponse> {
        try {
            const {data} = await RestAPI.post<AuthByLoginResponse>("", {
                method: "authorizationByLogin",
                login,
                password,
            });
            return data
        } catch (e) {
            return { auth: false, error: 'Не удалось авторизоваться', userId: 0}
        }

    },
    async loginByHash(login: string, passwordHash: string) {
        return await RestAPI.post("", {
            method: "loginByHash",
            login,
            hash: passwordHash
        });
    }
};
